import { api } from '../../api/instance';

export const cardService = {
  // GET /v3/cards/cards — именно такой путь у `cards#index` в routes.rb:389.
  // GET /v3/cards без суффикса возвращает 404.
  getCards() { return api.get('v3/cards/cards'); },
  addCard() { return api.post('v3/cards', {}); },
  deleteCard(id) { return api.del(`v3/cards/${id}`); },
};



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/stores/cardStore/service.js